import React, { useId } from 'react';

const expandCollapseContent = (props) => {
  const { content } = props;
  const { shareBlock } = props;
  const shareButtonClassName = shareBlock.substring(1)
  const randomId = useId();

  const showMore = () => {
    if (document.getElementById(randomId).innerHTML === '-') {
      document.querySelectorAll(shareBlock).forEach((el) => el.innerHTML = null);
      document.querySelectorAll(`.${shareButtonClassName}`).forEach((el) => el.innerHTML = '+');
      document.getElementById(randomId).innerHTML = '+'
    } else {
      document.querySelectorAll(shareBlock).forEach((el) => el.innerHTML = null);
      document.querySelectorAll(`.${shareButtonClassName}`).forEach((el) => el.innerHTML = '+');
      document.getElementById(randomId).innerHTML = '-'

      document.querySelector(shareBlock).innerHTML = content
    }
  };

  return (
    <div className="pl-2 float-right">
      <div onClick={showMore} className="cursor-pointer flex justify-center border border-black w-4 h-4">
        <span id={randomId} className={`${shareButtonClassName} -mt-1 text-base`}>+</span>
      </div>
    </div>
  );
};

export default expandCollapseContent;
